export const SUBSCRIPTION_ERRORS = {
  SUBSCRIPTION_NOT_FOUND_APPLE_PAY_ENABLED: 'E1066',
  SUBSCRIPTION_NOT_FOUND: 'E1037',
} as const;

export const ERROR_CODES = {
  UNAUTHORIZED: 'E1002',
  TOKEN_EXPIRED: 'E1012',
  NEW_AUTH_ACCESS_TOKEN_EXPIRED: 'E3002',
  NEW_AUTH_UNAUTHORIZED: 'E1002',
  INVALID_SESSION: 'E1202',
  HAS_SCOPE_ERROR_CODE: 'E1233',
  USER_EMAIL_NOT_VERIFIED: 'E1251',
  PROFILE_INACTIVE: 'E1273',
  PIN_LOCKED: 'E1279',
};

export const isSubscriptionError = (errorCode: string) => {
  return Object.keys(SUBSCRIPTION_ERRORS).includes(errorCode);
};
